export function isSpecialDefaultGallection(gallection) {
    if (gallection.type === 'private_collection') {
        return gallection.name === 'Private';
    }
    return gallection.name === 'Featured';
}
